// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  overflow-x: hidden;
  background-size: 650px 500px;
  background-position: calc(100% - 2px) 100px;
  color: white;
}

/* Grain / Vintage effect */
body::after {
  content: "";
  position: fixed;
  inset: 0;
  background: url("https://www.transparenttextures.com/patterns/grain.png");
  opacity: 0.25;
  pointer-events: none;
}

.filter-toggle,
.filter-category .close-filter {
  display: none;
}

.product-categories {
  width: 95%;
  /* border: 1px solid #ccc; */
  border-radius: 10px;
  padding: 10px;
  font-family: Arial, sans-serif;
  color: black;
  /* box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); */
  text-align: center;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  gap: 150px;
  margin-top: 15rem;
  /* height: 200px; */
}

.product-items {
  padding: 8px;
  border-bottom: 1px solid #ddd;
}

.product-items:last-child {
  border-bottom: none;
}


/* product item*/

.productContainer {
  color: black;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 55px;
  padding: 20px;
  margin-left: 10px;
  flex: 1 1;
  position: relative;

}

.productBox {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
  border: 2px solid transparent;
  transition: border-color 0.3s ease;
  transition: transform 0.5s ease-in-out;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(25% - 15px);

}

.productBox:hover {
  border-color: #1d0170;
  transform: scale(1.05);
  scroll-behavior: smooth;
}

.productImage {
  width: 100%;
  height: auto;
  max-width: 100px;
  max-height: 100px;
  object-fit: contain;
  border-radius: 5px;
}

.productName {
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0;
}

.productCategory {
  font-size: 14px;
  color: gray;
}

.productPrice {
  font-size: 16px;
  font-weight: bold;
  margin: 10px 0;
}

.productIcons {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  gap: 10px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.productBox:hover .productIcons {
  opacity: 1;
}

.wishlistButton,
.compareButton,
.previewButton {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: gray;
  transition: color 0.3s ease-in-out;
}

.wishlistButton:hover,
.compareButton:hover,
.previewButton:hover {
  color: black;
}

.addTocartButton {
  background: #068ce5;
  color: white;
  padding: 8px 12px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  font-size: 14px;
  margin-top: 10px;
}

.addTocartButton:hover {
  background: #1d0170;
}


.product-container-wrapper {
  display: flex;
  align-items: flex-start;
  color: black;
  justify-content: flex-start;
  position: relative;
  width: 100%;
  margin-top: 10rem;
}

.filter-category {
  margin-left: 20px;
  width: 250px;
  padding: 10px;
  background: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 0 0 250px;
}


.filter-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
}

/* Add some basic styling to the home button */
.category-buttons {
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
  justify-content: center;
  margin-top: 60px;
}

.category-button {
  width: 150px;
  height: 40px;
  border-radius: 50px;
  border: none;
  background-color: #007bff;
  color: whitesmoke;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
  justify-content: center;
  padding: 10px;
}

.category-button:hover {
  background-color: #1d0170;
}

.category-buttons-wrapper {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 1rem;
}

.home-button {
  margin-top: 60px;
  gap: 5px;
  width: 150px;
  height: 40px;
  border-radius: 50px;
  background-color: #007bff;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  transition: 0.3s;
}

.home-button:hover {
  background-color: #1d0170;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 10px;
}

.pagination button {
  margin: 0 5px;
  padding: 8px;
  cursor: pointer;
  border-radius: 80px;
}

.pagination button[disabled] {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination button:hover:not([disabled]) {
  background-color: #f0f0f0;
}

.deals-container {
  margin-top: 20px;
  padding: 20px;
  border-radius: 10px;
}

.productActions {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 10px 0;
  opacity: 0;
  transform: translateY(10px);
  transition: 0.3s ease;
}

/* Show only on hover */
.productBox:hover .productActions {
  opacity: 1;
  transform: translateY(0);
}

.icon-btn {
  background: #fff;
  border: none;
  padding: 8px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  transition: 0.3s;
}

.icon-btn:hover {
  transform: scale(1.1);
}

.wishlist-btn {
  color: red;
}

.view-btn {
  color: #333;
}


@media (max-width: 768px) {
  .category-buttons-wrapper {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    justify-content: flex-start;
    gap: 10px;
    padding: 10px;
    margin-bottom: 25rem;
  }

  .home-button {
    flex: 0 0 auto;
    width: 150px;
    margin-top: 55px;
  }

  .product-container-wrapper {
    margin-top: -42rem;
  }

  .productContainer {
    width: 100%;
  }

  .productContainer {
    flex-wrap: wrap;
    gap: 15px;
    padding: 10px;
  }

  .productBox {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 10px);
    padding: 15px;
  }

  .filter-category .close-filter {
    display: block;
  }

  .filter-toggle {
    display: flex;
    position: fixed;
    bottom: 20px;
    left: 5px;
    z-index: 1000;
    background: #007bff;
    color: white;
    border: none;
    padding: 12px;
    border-radius: 50%;
    font-size: 20px;
    cursor: pointer;
    margin-bottom: 40px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  }

  .filter-category {
    position: fixed;
    top: 0;
    left: -100%;
    width: 75%;
    height: 720px;
    margin-top: 40px;
    background: white;
    margin-left: 0;
    z-index: 999;
    transition: 0.3s;
    overflow-y: auto;
    padding: 10px;
    padding-left: 50px;
    color: black;
  }

  .filter-category.active {
    left: 0;
  }

  .close-filter {
    font-size: 20px;
    background: none;
    border: none;
    float: right;
    cursor: pointer;
  }

}

/* ===== Professional Product Page Override ===== */
:root {
  --pp-bg: #f2f6fc;
  --pp-surface: #ffffff;
  --pp-surface-soft: #f7fbff;
  --pp-text: #12263f;
  --pp-muted: #66788f;
  --pp-border: #d9e7f5;
  --pp-brand: #0f62ad;
  --pp-brand-dark: #0a4f8f;
  --pp-shadow-soft: 0 10px 24px rgba(14, 38, 66, 0.08);
  --pp-shadow-raise: 0 16px 34px rgba(14, 38, 66, 0.14);
}

body {
  background:
    radial-gradient(circle at 8% 0%, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0) 34%),
    radial-gradient(circle at 94% 8%, rgba(187, 214, 240, 0.42) 0%, rgba(187, 214, 240, 0) 36%),
    linear-gradient(180deg, #f8fbff 0%, #f2f6fc 56%, #edf3fa 100%);
  color: var(--pp-text);
}

body::after {
  display: none;
}

.product-categories {
  width: min(96%, 1240px);
  margin: 18px auto 0;
  padding: 0;
  color: var(--pp-text);
  position: static;
  transform: none;
  gap: 0;
}

.category-buttons-wrapper {

  margin: 2rem;

  margin-top: 1rem;

  padding: 12px;
  border: 1px solid var(--pp-border);
  border-radius: 16px;
  background: var(--pp-surface);
  box-shadow: var(--pp-shadow-soft);
  justify-content: flex-start;
}

.category-buttons {
  margin: 0;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.home-button,
.category-button {
  width: auto;
  height: 38px;
  margin: 0;
  padding: 0 16px;
  border-radius: 999px;
  border: 1px solid #c4dbef;
  background: #f3f8ff;
  color: var(--pp-brand-dark);
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
}

.home-button:hover,
.category-button:hover {
  background: var(--pp-brand);
  color: #ffffff;
  border-color: transparent;
}

.product-container-wrapper {
  width: min(96%, 1240px);
  margin: 16px auto 0;
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
  margin-top: -1rem;
  position: relative;
}

.filter-category {
  position: sticky;
  top: 128px;
  width: 100%;
  margin: 0;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid var(--pp-border);
  background: var(--pp-surface);
  box-shadow: var(--pp-shadow-soft);
  color: var(--pp-text);
}

.filter-category h3,
.filter-category h4 {
  margin: 8px 0;
  color: var(--pp-text);
}

.filter-category h3 {
  font-size: 1.05rem;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--pp-border);
}

.filter-category h4 {
  font-size: 0.95rem;
}

.filter-category label,
.filter-category div {
  color: var(--pp-muted);
  font-size: 14px;
}

.productContainer {
  margin-left: 2rem;
  padding: 0;
  gap: 14px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
}

.productBox {
  flex: none;
  border: 1px solid var(--pp-border);
  border-radius: 16px;
  background: var(--pp-surface);
  box-shadow: var(--pp-shadow-soft);
  padding: 14px;
  text-align: left;
  overflow: hidden;
  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease,
    border-color 0.25s ease;
}

.productBox:hover {
  border-color: #bfd7ee;
  transform: translateY(-5px);
  box-shadow: var(--pp-shadow-raise);
}

.productImage {
  width: 100%;
  max-width: none;
  height: 170px;
  max-height: none;
  display: block;
  box-sizing: border-box;
  margin: 0 auto;
  object-fit: contain;
  object-position: center;
  border-radius: 12px;
  border: 1px solid #e3edf8;
  background: var(--pp-surface-soft);
  padding: 8px;
}

.productBox h2 {
  margin: 12px 0 6px;
  font-size: 0.98rem;
  line-height: 1.35;
  color: var(--pp-text);
  min-height: 2.7em;
}

.productBox p {
  margin: 4px 0;
  color: var(--pp-muted);
  font-size: 0.88rem;
}

.productBox p:last-of-type {
  color: var(--pp-brand-dark);
  font-size: 1rem;
  font-weight: 800;
}

.productActions {
  opacity: 1;
  transform: none;
  justify-content: flex-start;
  margin: 10px 0 8px;
}

.icon-btn {
  width: 34px;
  height: 34px;
  padding: 0;
  border-radius: 10px;
  border: 1px solid #d3e3f3;
  background: #f3f8ff;
  box-shadow: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon-btn:hover {
  transform: translateY(-1px);
  background: #e8f2ff;
}

.addTocartButton {
  width: 100%;
  min-height: 40px;
  border-radius: 10px;
  border: none;
  background: linear-gradient(120deg, var(--pp-brand) 0%, var(--pp-brand-dark) 100%);
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.addTocartButton:hover {
  filter: brightness(1.04);
}

.pagination {
  margin: 24px 0 6px;
  gap: 6px;
}

.pagination button {
  min-width: 36px;
  height: 36px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid #c8dced;
  background: #ffffff;
  color: var(--pp-brand-dark);
  font-weight: 700;
}

.pagination button:hover:not([disabled]) {
  background: #edf5ff;
}

.pagination button[disabled] {
  background: #e8eff8;
  color: #8799ae;
}

@media (max-width: 992px) {
  .product-container-wrapper {
    grid-template-columns: 1fr;
  }

  .filter-category {
    position: static;
  }
}

@media (max-width: 768px) {
  .product-categories,
  .product-container-wrapper {
    width: 94%;
  }

  .category-buttons-wrapper {
    padding: 10px;
  }

  .category-buttons-wrapper {
    flex-wrap: nowrap;
    overflow-x: auto;
    gap: 8px;
  }

  .category-buttons {
    flex-wrap: nowrap;
  }

  .home-button,
  .category-button {
    flex: 0 0 auto;
    height: 34px;
    font-size: 13px;
    padding: 0 12px;
  }

  .productContainer {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  margin-left: 0rem;
  padding-left:60px;
  padding: 0;
  display: grid;

  }

  .productBox {
    padding: 10px;
    border-radius: 12px;
  }

  .productImage {
    height: 132px;
  }

  .productBox h2 {
    font-size: 0.86rem;
  }

  .productBox p {
    font-size: 0.8rem;
  }

  .addTocartButton {
    min-height: 36px;
    font-size: 13px;
  }
    .filter-category {
    position: fixed;
    top: 0;
    left: -100%;
    width: 75%;
    height: 100vh;
    background: white;
    z-index: 999;
    transition: 0.3s ease;
    overflow-y: auto;
    padding: 14px;
  }

  .filter-category.active {
    left: 0; /* THIS is what opens it */
  }

  .filter-toggle {
    display: flex;
  }

  .close-filter {
    display: block;
  }

  .filter-toggle {
    left: 14px;
    right: auto;
    bottom: 78px;
    margin-bottom: 0;
    background: linear-gradient(120deg, var(--pp-brand) 0%, var(--pp-brand-dark) 100%);
    box-shadow: 0 10px 22px rgba(12, 37, 66, 0.25);
  }

  .filter-category {
    width: 70%;
    max-width: 320px;
    height: auto;
    margin-top: 60px;
    border-radius: 0 14px 14px 0;
    padding: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ProductPage/product.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,2CAA2C;EAC3C,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,yEAAyE;EACzE,aAAa;EACb,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;;AAGA,gBAAgB;;AAEhB;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,SAAO;EACP,kBAAkB;;AAEpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,sCAAsC;EACtC,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;;AAE5B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,kCAAkC;AACpC;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,UAAU;EACV,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE;IACE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,SAAS;IACT,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,SAAS;IACT,aAAa;EACf;;EAEA;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,YAAY;IACZ,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,wCAAwC;EAC1C;;EAEA;IACE,eAAe;IACf,MAAM;IACN,WAAW;IACX,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;AAEF;;AAEA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,oDAAoD;EACpD,qDAAqD;AACvD;;AAEA;EACE;;;kEAGgE;EAChE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,MAAM;AACR;;AAEA;;EAEE,YAAY;;EAEZ,gBAAgB;;EAEhB,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;EAC3B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,6BAA6B;EAC7B,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,aAAa;EACb,4DAA4D;AAC9D;;AAEA;EACE,UAAU;EACV,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,iCAAiC;EACjC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB;;;2BAGyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kFAAkF;EAClF,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,cAAc;IACd,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gDAAgD;IAChD,SAAS;EACX,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,aAAa;;EAEb;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;IACE;IACA,eAAe;IACf,MAAM;IACN,WAAW;IACX,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,OAAO,EAAE,0BAA0B;EACrC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kFAAkF;IAClF,8CAA8C;EAChD;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,aAAa;EACf;AACF","sourcesContent":["body {\n  overflow-x: hidden;\n  background-size: 650px 500px;\n  background-position: calc(100% - 2px) 100px;\n  color: white;\n}\n\n/* Grain / Vintage effect */\nbody::after {\n  content: \"\";\n  position: fixed;\n  inset: 0;\n  background: url(\"https://www.transparenttextures.com/patterns/grain.png\");\n  opacity: 0.25;\n  pointer-events: none;\n}\n\n.filter-toggle,\n.filter-category .close-filter {\n  display: none;\n}\n\n.product-categories {\n  width: 95%;\n  /* border: 1px solid #ccc; */\n  border-radius: 10px;\n  padding: 10px;\n  font-family: Arial, sans-serif;\n  color: black;\n  /* box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); */\n  text-align: center;\n  position: relative;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  gap: 150px;\n  margin-top: 15rem;\n  /* height: 200px; */\n}\n\n.product-items {\n  padding: 8px;\n  border-bottom: 1px solid #ddd;\n}\n\n.product-items:last-child {\n  border-bottom: none;\n}\n\n\n/* product item*/\n\n.productContainer {\n  color: black;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 55px;\n  padding: 20px;\n  margin-left: 10px;\n  flex: 1;\n  position: relative;\n\n}\n\n.productBox {\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  position: relative;\n  border: 2px solid transparent;\n  transition: border-color 0.3s ease;\n  transition: transform 0.5s ease-in-out;\n  flex: 0 0 calc(25% - 15px);\n\n}\n\n.productBox:hover {\n  border-color: #1d0170;\n  transform: scale(1.05);\n  scroll-behavior: smooth;\n}\n\n.productImage {\n  width: 100%;\n  height: auto;\n  max-width: 100px;\n  max-height: 100px;\n  object-fit: contain;\n  border-radius: 5px;\n}\n\n.productName {\n  font-size: 18px;\n  font-weight: bold;\n  margin: 10px 0;\n}\n\n.productCategory {\n  font-size: 14px;\n  color: gray;\n}\n\n.productPrice {\n  font-size: 16px;\n  font-weight: bold;\n  margin: 10px 0;\n}\n\n.productIcons {\n  display: flex;\n  justify-content: center;\n  margin-top: 10px;\n  gap: 10px;\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n}\n\n.productBox:hover .productIcons {\n  opacity: 1;\n}\n\n.wishlistButton,\n.compareButton,\n.previewButton {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  color: gray;\n  transition: color 0.3s ease-in-out;\n}\n\n.wishlistButton:hover,\n.compareButton:hover,\n.previewButton:hover {\n  color: black;\n}\n\n.addTocartButton {\n  background: #068ce5;\n  color: white;\n  padding: 8px 12px;\n  border: none;\n  cursor: pointer;\n  border-radius: 5px;\n  font-size: 14px;\n  margin-top: 10px;\n}\n\n.addTocartButton:hover {\n  background: #1d0170;\n}\n\n\n.product-container-wrapper {\n  display: flex;\n  align-items: flex-start;\n  color: black;\n  justify-content: flex-start;\n  position: relative;\n  width: 100%;\n  margin-top: 10rem;\n}\n\n.filter-category {\n  margin-left: 20px;\n  width: 250px;\n  padding: 10px;\n  background: #f9f9f9;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  flex: 0 0 250px;\n}\n\n\n.filter-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n  font-size: 14px;\n  color: #333;\n}\n\n/* Add some basic styling to the home button */\n.category-buttons {\n  display: flex;\n  gap: 30px;\n  margin-bottom: 20px;\n  justify-content: center;\n  margin-top: 60px;\n}\n\n.category-button {\n  width: 150px;\n  height: 40px;\n  border-radius: 50px;\n  border: none;\n  background-color: #007bff;\n  color: whitesmoke;\n  font-size: 20px;\n  font-weight: bold;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: 0.3s;\n  justify-content: center;\n  padding: 10px;\n}\n\n.category-button:hover {\n  background-color: #1d0170;\n}\n\n.category-buttons-wrapper {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 1rem;\n}\n\n.home-button {\n  margin-top: 60px;\n  gap: 5px;\n  width: 150px;\n  height: 40px;\n  border-radius: 50px;\n  background-color: #007bff;\n  border: none;\n  color: white;\n  font-size: 20px;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n.home-button:hover {\n  background-color: #1d0170;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\n.pagination button {\n  margin: 0 5px;\n  padding: 8px;\n  cursor: pointer;\n  border-radius: 80px;\n}\n\n.pagination button[disabled] {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.pagination button:hover:not([disabled]) {\n  background-color: #f0f0f0;\n}\n\n.deals-container {\n  margin-top: 20px;\n  padding: 20px;\n  border-radius: 10px;\n}\n\n.productActions {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin: 10px 0;\n  opacity: 0;\n  transform: translateY(10px);\n  transition: 0.3s ease;\n}\n\n/* Show only on hover */\n.productBox:hover .productActions {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.icon-btn {\n  background: #fff;\n  border: none;\n  padding: 8px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 16px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n  transition: 0.3s;\n}\n\n.icon-btn:hover {\n  transform: scale(1.1);\n}\n\n.wishlist-btn {\n  color: red;\n}\n\n.view-btn {\n  color: #333;\n}\n\n\n@media (max-width: 768px) {\n  .category-buttons-wrapper {\n    display: flex;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    justify-content: flex-start;\n    gap: 10px;\n    padding: 10px;\n    margin-bottom: 25rem;\n  }\n\n  .home-button {\n    flex: 0 0 auto;\n    width: 150px;\n    margin-top: 55px;\n  }\n\n  .product-container-wrapper {\n    margin-top: -42rem;\n  }\n\n  .productContainer {\n    width: 100%;\n  }\n\n  .productContainer {\n    flex-wrap: wrap;\n    gap: 15px;\n    padding: 10px;\n  }\n\n  .productBox {\n    flex: 0 0 calc(50% - 10px);\n    padding: 15px;\n  }\n\n  .filter-category .close-filter {\n    display: block;\n  }\n\n  .filter-toggle {\n    display: flex;\n    position: fixed;\n    bottom: 20px;\n    left: 5px;\n    z-index: 1000;\n    background: #007bff;\n    color: white;\n    border: none;\n    padding: 12px;\n    border-radius: 50%;\n    font-size: 20px;\n    cursor: pointer;\n    margin-bottom: 40px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n  }\n\n  .filter-category {\n    position: fixed;\n    top: 0;\n    left: -100%;\n    width: 75%;\n    height: 720px;\n    margin-top: 40px;\n    background: white;\n    margin-left: 0;\n    z-index: 999;\n    transition: 0.3s;\n    overflow-y: auto;\n    padding: 10px;\n    padding-left: 50px;\n    color: black;\n  }\n\n  .filter-category.active {\n    left: 0;\n  }\n\n  .close-filter {\n    font-size: 20px;\n    background: none;\n    border: none;\n    float: right;\n    cursor: pointer;\n  }\n\n}\n\n/* ===== Professional Product Page Override ===== */\n:root {\n  --pp-bg: #f2f6fc;\n  --pp-surface: #ffffff;\n  --pp-surface-soft: #f7fbff;\n  --pp-text: #12263f;\n  --pp-muted: #66788f;\n  --pp-border: #d9e7f5;\n  --pp-brand: #0f62ad;\n  --pp-brand-dark: #0a4f8f;\n  --pp-shadow-soft: 0 10px 24px rgba(14, 38, 66, 0.08);\n  --pp-shadow-raise: 0 16px 34px rgba(14, 38, 66, 0.14);\n}\n\nbody {\n  background:\n    radial-gradient(circle at 8% 0%, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0) 34%),\n    radial-gradient(circle at 94% 8%, rgba(187, 214, 240, 0.42) 0%, rgba(187, 214, 240, 0) 36%),\n    linear-gradient(180deg, #f8fbff 0%, #f2f6fc 56%, #edf3fa 100%);\n  color: var(--pp-text);\n}\n\nbody::after {\n  display: none;\n}\n\n.product-categories {\n  width: min(96%, 1240px);\n  margin: 18px auto 0;\n  padding: 0;\n  color: var(--pp-text);\n  position: static;\n  transform: none;\n  gap: 0;\n}\n\n.category-buttons-wrapper {\n\n  margin: 2rem;\n\n  margin-top: 1rem;\n\n  padding: 12px;\n  border: 1px solid var(--pp-border);\n  border-radius: 16px;\n  background: var(--pp-surface);\n  box-shadow: var(--pp-shadow-soft);\n  justify-content: flex-start;\n}\n\n.category-buttons {\n  margin: 0;\n  gap: 10px;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n\n.home-button,\n.category-button {\n  width: auto;\n  height: 38px;\n  margin: 0;\n  padding: 0 16px;\n  border-radius: 999px;\n  border: 1px solid #c4dbef;\n  background: #f3f8ff;\n  color: var(--pp-brand-dark);\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.home-button:hover,\n.category-button:hover {\n  background: var(--pp-brand);\n  color: #ffffff;\n  border-color: transparent;\n}\n\n.product-container-wrapper {\n  width: min(96%, 1240px);\n  margin: 16px auto 0;\n  display: grid;\n  grid-template-columns: 280px minmax(0, 1fr);\n  gap: 18px;\n  align-items: start;\n  margin-top: -1rem;\n  position: relative;\n}\n\n.filter-category {\n  position: sticky;\n  top: 128px;\n  width: 100%;\n  margin: 0;\n  padding: 16px;\n  border-radius: 16px;\n  border: 1px solid var(--pp-border);\n  background: var(--pp-surface);\n  box-shadow: var(--pp-shadow-soft);\n  color: var(--pp-text);\n}\n\n.filter-category h3,\n.filter-category h4 {\n  margin: 8px 0;\n  color: var(--pp-text);\n}\n\n.filter-category h3 {\n  font-size: 1.05rem;\n  padding-bottom: 10px;\n  border-bottom: 1px solid var(--pp-border);\n}\n\n.filter-category h4 {\n  font-size: 0.95rem;\n}\n\n.filter-category label,\n.filter-category div {\n  color: var(--pp-muted);\n  font-size: 14px;\n}\n\n.productContainer {\n  margin-left: 2rem;\n  padding: 0;\n  gap: 14px;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));\n}\n\n.productBox {\n  flex: none;\n  border: 1px solid var(--pp-border);\n  border-radius: 16px;\n  background: var(--pp-surface);\n  box-shadow: var(--pp-shadow-soft);\n  padding: 14px;\n  text-align: left;\n  overflow: hidden;\n  transition:\n    transform 0.25s ease,\n    box-shadow 0.25s ease,\n    border-color 0.25s ease;\n}\n\n.productBox:hover {\n  border-color: #bfd7ee;\n  transform: translateY(-5px);\n  box-shadow: var(--pp-shadow-raise);\n}\n\n.productImage {\n  width: 100%;\n  max-width: none;\n  height: 170px;\n  max-height: none;\n  display: block;\n  box-sizing: border-box;\n  margin: 0 auto;\n  object-fit: contain;\n  object-position: center;\n  border-radius: 12px;\n  border: 1px solid #e3edf8;\n  background: var(--pp-surface-soft);\n  padding: 8px;\n}\n\n.productBox h2 {\n  margin: 12px 0 6px;\n  font-size: 0.98rem;\n  line-height: 1.35;\n  color: var(--pp-text);\n  min-height: 2.7em;\n}\n\n.productBox p {\n  margin: 4px 0;\n  color: var(--pp-muted);\n  font-size: 0.88rem;\n}\n\n.productBox p:last-of-type {\n  color: var(--pp-brand-dark);\n  font-size: 1rem;\n  font-weight: 800;\n}\n\n.productActions {\n  opacity: 1;\n  transform: none;\n  justify-content: flex-start;\n  margin: 10px 0 8px;\n}\n\n.icon-btn {\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border-radius: 10px;\n  border: 1px solid #d3e3f3;\n  background: #f3f8ff;\n  box-shadow: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon-btn:hover {\n  transform: translateY(-1px);\n  background: #e8f2ff;\n}\n\n.addTocartButton {\n  width: 100%;\n  min-height: 40px;\n  border-radius: 10px;\n  border: none;\n  background: linear-gradient(120deg, var(--pp-brand) 0%, var(--pp-brand-dark) 100%);\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0.2px;\n}\n\n.addTocartButton:hover {\n  filter: brightness(1.04);\n}\n\n.pagination {\n  margin: 24px 0 6px;\n  gap: 6px;\n}\n\n.pagination button {\n  min-width: 36px;\n  height: 36px;\n  padding: 0 12px;\n  border-radius: 10px;\n  border: 1px solid #c8dced;\n  background: #ffffff;\n  color: var(--pp-brand-dark);\n  font-weight: 700;\n}\n\n.pagination button:hover:not([disabled]) {\n  background: #edf5ff;\n}\n\n.pagination button[disabled] {\n  background: #e8eff8;\n  color: #8799ae;\n}\n\n@media (max-width: 992px) {\n  .product-container-wrapper {\n    grid-template-columns: 1fr;\n  }\n\n  .filter-category {\n    position: static;\n  }\n}\n\n@media (max-width: 768px) {\n  .product-categories,\n  .product-container-wrapper {\n    width: 94%;\n  }\n\n  .category-buttons-wrapper {\n    padding: 10px;\n  }\n\n  .category-buttons-wrapper {\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    gap: 8px;\n  }\n\n  .category-buttons {\n    flex-wrap: nowrap;\n  }\n\n  .home-button,\n  .category-button {\n    flex: 0 0 auto;\n    height: 34px;\n    font-size: 13px;\n    padding: 0 12px;\n  }\n\n  .productContainer {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 12px;\n  margin-left: 0rem;\n  padding-left:60px;\n  padding: 0;\n  display: grid;\n\n  }\n\n  .productBox {\n    padding: 10px;\n    border-radius: 12px;\n  }\n\n  .productImage {\n    height: 132px;\n  }\n\n  .productBox h2 {\n    font-size: 0.86rem;\n  }\n\n  .productBox p {\n    font-size: 0.8rem;\n  }\n\n  .addTocartButton {\n    min-height: 36px;\n    font-size: 13px;\n  }\n    .filter-category {\n    position: fixed;\n    top: 0;\n    left: -100%;\n    width: 75%;\n    height: 100vh;\n    background: white;\n    z-index: 999;\n    transition: 0.3s ease;\n    overflow-y: auto;\n    padding: 14px;\n  }\n\n  .filter-category.active {\n    left: 0; /* THIS is what opens it */\n  }\n\n  .filter-toggle {\n    display: flex;\n  }\n\n  .close-filter {\n    display: block;\n  }\n\n  .filter-toggle {\n    left: 14px;\n    right: auto;\n    bottom: 78px;\n    margin-bottom: 0;\n    background: linear-gradient(120deg, var(--pp-brand) 0%, var(--pp-brand-dark) 100%);\n    box-shadow: 0 10px 22px rgba(12, 37, 66, 0.25);\n  }\n\n  .filter-category {\n    width: 70%;\n    max-width: 320px;\n    height: auto;\n    margin-top: 60px;\n    border-radius: 0 14px 14px 0;\n    padding: 14px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
